import type { ExtensionConfig } from '@goto/shell'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-training-app',
  get url() {
    const version = getLaunchDarklyFlag(LaunchDarklyVariations.OOS_TRAINING_VERSION)
    return new URL(getOOSArtifactUrl('training-extension', version))
  },
}

export default extensionConfig
